module.exports = __webpack_public_path__ + "img/character3.c0aa4edf.png";